import Image from 'next/image';

import { quantaArtwork } from '@/assets/animated-artwork';
import { cn } from '@/utils/cn';

import SoftenedArtwork from './SoftenedArtwork';

interface QuantaIconProps {
  alt?: string;
  size?: number;
  className?: string;
}

/** Shared blue Quanta mark; only its white surfaces soften in light mode. */
export default function QuantaIcon({ alt = '', size = 24, className }: QuantaIconProps) {
  return (
    <SoftenedArtwork className="inline-flex shrink-0">
      <Image src={quantaArtwork.poster} alt={alt} width={size} height={size} className={cn('object-contain', className)} />
    </SoftenedArtwork>
  );
}
